import { render } from "./sectiond.vue?vue&type=template&id=3b454dd3"
import script from "./sectiond.vue?vue&type=script&lang=js"
export * from "./sectiond.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__